<template>
  <div class="table-com">
    <div class="header" :style="{background:chooseCol().color}">{{chooseCol().title}} ( 20% )</div>
    <div class="body" v-for="item in 2">
      <div>
        <p>
          <span class="special" :style="{background:chooseCol().color}">银行理财</span>
        </p>
        <p>日日聚财A19903</p>
      </div>
      <div>
        <p>
          <span class="move">{{chooseCol().t2}}</span>
        </p>
        <p style="color:#F95353">14.44%</p>
      </div>
      <div>
        <p>
          <span class="move">{{chooseCol().t3}}</span>
        </p>
        <p>1000,000</p>
      </div>
      <div>
        <p>
          <span class="button--blue position-enter" @click="changeProduct(item)">替换产品</span>
        </p>
      </div>
    </div>
    <el-dialog title="替换产品" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
      <el-form inline :model="originData" ref="searchForm">
        <el-form-item label="产品代码:" prop="cis">
          <el-input placeholder="请输入" v-model.trim="originData.cis"></el-input>
        </el-form-item>
        <el-form-item label="产品名称:" prop="custName">
          <el-input placeholder="请输入" v-model.trim="originData.custName"></el-input>
        </el-form-item>
        <el-form-item label="起购金额(元):" prop="custName">
          <el-input placeholder="请输入" v-model.trim="originData.custName"></el-input>
        </el-form-item>
        <el-form-item label="投资期限(天):" class="age-container">
          <el-input placeholder="下限值" v-model="originData.ageStart" style="width:200px"></el-input>
          <span style="margin:auto 10px;color:#999999">至</span>
          <el-input placeholder="上限值" v-model="originData.ageEnd" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="风险等级:" prop="certificateNumber">
          <!-- <el-input placeholder="请输入证件号码" v-model.trim="originData.certificateNumber"></el-input> -->
          <el-select v-model.trim="originData.certificateNumber">
            <el-option label="1" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品状态:" prop="custName">
          <el-select v-model.trim="originData.certificateNumber">
            <el-option label="1" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上下架状态:" prop="custName">
          <el-select v-model.trim="originData.certificateNumber">
            <el-option label="1" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否重置:" prop="custName">
          <el-select v-model.trim="originData.certificateNumber">
            <el-option label="1" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="flex">
        <div>
          <el-button @click="reset">清空</el-button>
          <yh-button type="primary" @click="handleQueryClick">查询</yh-button>
        </div>
      </div>
      <el-table
        :row-key="getRowKeys"
        :header-cell-class-name="cellClass"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="date" label="产品代码"></el-table-column>
        <el-table-column prop="name" label="产品名称"></el-table-column>
        <el-table-column prop="date" label="产品状态"></el-table-column>
        <el-table-column prop="name" label="上下架状态"></el-table-column>
        <el-table-column prop="date" label="是否置顶"></el-table-column>
        <el-table-column prop="name" label="起购金额(元)"></el-table-column>
        <el-table-column prop="name" label="投资期限"></el-table-column>
      </el-table>
      <yh-pagination :page.sync="currentPage" :total="sumCount" />
    </el-dialog>
  </div>
</template>

<script>
/*eslint-disable*/
const col = {
  0: {
    title: "固收类",
    t1: "银行理财",
    t2: "业绩比较基准",
    t3: "起投金额",
    color: "#f4f7fd"
  },
  1: {
    title: "权益类",
    t1: "混合型基金",
    t2: "近一月涨幅",
    t3: "单位净值",
    color: "#e6f7ef"
  },
  2: {
    title: "货币类",
    t1: "银行理财",
    t2: "业绩比较基准",
    t3: "起投金额",
    color: "#f7f6f9"
  },
  3: {
    title: "固收类",
    t1: "银行理财",
    t2: "近一月涨幅",
    t3: "单位净值",
    color: "#fdf6eb"
  }
};
export default {
  name: "tableCom",
  props: ["type"],
  data() {
    return {
      dialogVisible: false,
      currentPage: 1,
      sumCount: 0,
      tableData: [
        { date: "test", name: "test" },
        { date: "test", name: "test" },
        { date: "test", name: "test" }
      ],
      // 初始数据
      originData: {
        cis: "",
        custName: "",
        certificateNumber: "",
        ageStart: "",
        ageEnd: "",
        // userId: sessionData.userId,
        // roleId: sessionData.roleId,
        // loginOrgnId: sessionData.orgnCode,
        // orgnInheritSign: sessionData.orgnInheritSign
        userId: "",
        roleId: "",
        loginOrgnId: "",
        orgnInheritSign: ""
      }
    };
  },
  created() {},
  computed: {},
  methods: {
    getRowKeys() {},
    cellClass(row) {
      if (row.columnIndex === 0) {
        //你需要判断的条件
        return "disabledCheck";
      }
    },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
    },
    // 控制关闭
    handleClose() {
      this.dialogVisible = false;
    },
    changeProduct() {
      this.dialogVisible = true;
    },
    chooseCol() {
      return col[this.type];
    },
    handleQueryClick() {
      this.$refs.table.clearSort();
      // this.searchParam = {
      //   ...this.originData,
      //   orderFlag: this.orderMap.ascending || null,
      //   orderKey: this.orderFlagMap.age || null,
      // };
      // this.getTableData();
      // this.currentPage = 1;
    },
    reset() {
      this.$refs.table.clearSort();
      this.originData.cis = "";
      this.originData.custName = "";
      this.originData.certificateNumber = "";
      this.originData.ageStart = "";
      this.originData.ageEnd = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.table-com {
  width: 554px;
  // div {
  //   & :not(:last-child) {
  //     border-bottom: none;
  //   }
  // }
}
.header {
  height: 40px;
  background: rgba(241, 247, 255, 1);
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(48, 49, 51, 1);
  padding-left: 15px;
}
.body {
  padding: 15px 10px 10px 15px;
  display: flex;
  height: 90px;
  box-sizing: border-box;
  border: 1px solid #eee;

  > div {
    width: 25%;
    p {
      height: 30px;
    }
    p:first-child {
      color: rgba(144, 147, 153, 1);
      font-size: 12px;
    }
    p:last-child {
      font-size: 14px;
      color: #303133;
    }
  }
}
.special {
  display: inline-block;
  height: 22px;
  line-height: 22px;
  background: rgba(241, 247, 255, 1);
  color: rgba(96, 98, 102, 1);
  padding: 0 10px;
}
.position-enter {
  transform: translate(60px, 15px);
}
.move {
  display: inline-block;
  transform: translate(0, 5px);
}
.el-table /deep/.disabledCheck .cell .el-checkbox__inner {
  display: none !important;
}
.el-table /deep/.disabledCheck .cell:before {
  content: "选择";
  position: absolute;
  right: 11px;
}

// .table-com .date-container .el-form-item__content .el-input {
//   width: 200px;
// }
</style>
<style>
/* .table-com .date-container .el-form-item__content .el-input {
  width: 200px;
} */
.el-table /deep/.disabledCheck .cell .el-checkbox__inner {
  display: none !important;
}
.el-table /deep/.disabledCheck .cell:before {
  content: "选择";
  position: absolute;
  right: 11px;
}
</style>
